export class Register {
  uname: string;
  fname: string;
  lname: string;
  phone: string;
  email: string;
  password: string;
}


// WEBPACK FOOTER //
// ./src/app/models/model.Register.ts